import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API, { getAuthConfig } from "../services/api";

function VisitorPass() {
  const navigate = useNavigate();
  const [visitor, setVisitor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPass = async () => {
      try{
        const res = await API.get("/pass/my-pass", getAuthConfig());
        setVisitor(res.data);
      } 
      catch(err){
        alert(err.response?.data?.message || "Could not load your pass");
      } 
      finally{
        setLoading(false);
      }
    };

    fetchPass();
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/visitor");
  };

  if(loading){
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-100">
        <p className="text-gray-600">Loading your pass...</p>
      </div>
    );
  }

  if(!visitor){
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-100 p-6">
        <div className="rounded-xl bg-white p-8 text-center shadow-lg">
          <p className="text-gray-700">Pass details are not available right now.</p>
          <button onClick={() => navigate("/visitor")} className="mt-4 rounded-lg bg-blue-600 px-4 py-2 text-white hover:bg-blue-700">
            Back to Visitor Portal
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="mx-auto max-w-2xl rounded-xl border border-gray-200 bg-white p-8 shadow-lg">
        <div className="mb-6 flex flex-wrap items-start justify-between gap-4">
          <div>
            <h1 className="text-2xl font-bold text-gray-800">My Visitor Pass</h1>
            <p className="mt-1 text-sm text-gray-500">Welcome, {visitor.name}</p>
          </div>
          <button onClick={handleLogout} className="rounded-lg bg-red-500 px-4 py-2 text-white hover:bg-red-600">
            Logout
          </button>
        </div>

        <div className="grid gap-6 md:grid-cols-[140px_1fr]">
          <div className="overflow-hidden rounded-xl border bg-gray-50">
            {visitor.photoUrl ? (
              <img src={visitor.photoUrl} alt={visitor.name} className="h-40 w-full object-cover" />
            ) : (
              <div className="flex h-40 items-center justify-center text-sm text-gray-400">No Photo</div>
            )}
          </div>

          <div className="space-y-3">
            <p><span className="font-semibold text-gray-800">Email:</span> {visitor.email}</p>
            <p><span className="font-semibold text-gray-800">Phone:</span> {visitor.phone}</p>
            <p><span className="font-semibold text-gray-800">Purpose:</span> {visitor.purpose || "General Visit"}</p>
            <p><span className="font-semibold text-gray-800">Status:</span> {visitor.status}</p>
            <p><span className="font-semibold text-gray-800">Scheduled:</span> {visitor.isScheduled ? "Yes" : "No"}</p>
            {visitor.isScheduled && (
              <p><span className="font-semibold text-gray-800">Visit Slot:</span> {visitor.visitDate} at {visitor.visitTime}</p>
            )}
            <p><span className="font-semibold text-gray-800">Pass Issued:</span> {visitor.passIssued ? "Yes" : "No"}</p>
          </div>
        </div>

        <div className="mt-8 rounded-xl bg-gray-50 p-5">
          {visitor.passUrl ? (
            <a
              href={visitor.passUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-block rounded-lg bg-green-600 px-5 py-3 font-bold text-white hover:bg-green-700"
            >
              Download PDF Pass
            </a>
          ) : (
            <p className="text-gray-600">Your pass will appear here after approval, scheduling, and pass generation.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default VisitorPass;
